import { t } from 'i18next'
import { AlertType } from 'src/components/shared/ui/AlertDialog/enums'
import ButtonPrimaryOutlined from 'src/components/shared/ui/ButtonPrimaryOutlined'
import DialogActions from 'src/components/shared/ui/DialogActions'
import ButtonSecondary from '../../ButtonSecondary'

type ActionButtonsProps = {
  type: AlertType
  close: () => void
  accept: () => void
  cancel: () => void
  primaryButtonText?: string
  secondaryButtonText?: string | null
}

export default function AlertActionButtons(props: ActionButtonsProps): JSX.Element {
  const { type, close, cancel, accept, primaryButtonText, secondaryButtonText } = props
  function returnResult() {
    close()
    accept()
  }

  switch (type) {
    case AlertType.INFO:
      return (
        <DialogActions>
          {secondaryButtonText !== null && (
            <ButtonPrimaryOutlined onClick={cancel}>
              {secondaryButtonText ?? t('actions.no')}
            </ButtonPrimaryOutlined>
          )}
          <ButtonSecondary onClick={returnResult}>
            {primaryButtonText ?? t('actions.yes')}
          </ButtonSecondary>
        </DialogActions>
      )
    case AlertType.ERROR:
    case AlertType.SUCCESS:
    case AlertType.WARNING:
      return (
        <DialogActions>
          {secondaryButtonText && (
            <ButtonPrimaryOutlined onClick={returnResult}>
              {secondaryButtonText}
            </ButtonPrimaryOutlined>
          )}
          <ButtonSecondary onClick={cancel}>{primaryButtonText ?? t('Aceptar')}</ButtonSecondary>
        </DialogActions>
      )
    default:
      return <></>
  }
}
